import React from "react";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import BaseModal from "../../../../components/ui/BaseModal";
import BaseButton from "../../../../components/ui/BaseButton";
import { showToast } from "../../../../store/toast/toastSlice";
import { activateCompanyUser } from "../../../../services/api/company";

const ConfirmActivateUserModal = ({
  activateModalOpen,
  setActivateModalOpen,
  userId,
  refetchUsers,
}) => {
  const dispatch = useDispatch();

  const { isPending: isActivating, mutateAsync: activateUserMutation } =
    useMutation({
      mutationFn: activateCompanyUser,
      onSuccess: () => {
        dispatch(
          showToast({
            message: "User activated successfully",
            type: "success",
          })
        );
        refetchUsers?.();
        setActivateModalOpen(false);
      },
      onError: (error) => {
        dispatch(
          showToast({
            message:
              error?.response?.data?.message || "Failed to activate user",
            type: "error",
          })
        );
      },
    });

  async function handleActivate() {
    try {
      await activateUserMutation(userId);
    } catch (err) {}
  }

  return (
    <BaseModal
      className="-top-72"
      open={activateModalOpen}
      close={() => setActivateModalOpen(false)}
    >
      <div className="container">
        <h6 className="text-dark border-bottom mb-4 pb-1">
          Are you sure you want to activate this user?
        </h6>
        <p>
          Once activated, the user will regain access and their status will be
          set to <b>Active</b>.
        </p>
      </div>

      <div
        className="flex items-center justify-center bg-white py-6 mt-3"
        style={{ boxShadow: "5px 0px 14px 5px rgba(0, 0, 0, 0.07)" }}
      >
        <BaseButton
          className="py-[5px] px-2 bg-[#E8E8E8] text-dark"
          fullWidth={false}
          onClick={() => setActivateModalOpen(false)}
        >
          Cancel
        </BaseButton>
        <BaseButton
          disabled={isActivating}
          isLoading={isActivating}
          className="py-[5px] px-4 ml-4"
          color="primary"
          fullWidth={false}
          onClick={handleActivate}
        >
          Activate
        </BaseButton>
      </div>
    </BaseModal>
  );
};

export default ConfirmActivateUserModal;
